import { Carousel, Image } from 'antd'

import React from 'react'

import './style.scss'

const GalleryGrid = ({ images }) => {
  return (
    <Carousel
      arrows
      adaptiveHeight
      className="gallery-grid"
    >
      {images.map((img) => (
        <div key={img.id}>
          <Image
            className="img"
            src={img.fullName}
          />
        </div>
      ))}
    </Carousel>
  )
}

export default GalleryGrid
